module.exports = __webpack_public_path__ + "static/media/42.850803d5.png";